import React from 'react';
import {
  IonPage,
  IonIcon,
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { peopleOutline, addCircleOutline, listOutline, logOutOutline, lockClosedOutline, personOutline, peopleCircleOutline } from 'ionicons/icons';
import { useUser } from '../../context/UserContext';
import { AppBackground } from '../../components/PageHeader';
import './dashboard.css';

const Dashboard: React.FC = () => {
  const history = useHistory();
  const { user, logout } = useUser();

  const handleLogout = () => {
    logout();
    history.replace('/');
  };

  return (
    <IonPage className="app-page dashboard-page">
      <AppBackground />

      <div className="dashboard-wrapper">

        <div className="dashboard-header">
          <div className="header-left">
            <div className="header-avatar">
              <IonIcon icon={peopleOutline} />
            </div>
            <div>
              <p className="header-greeting">Bienvenido</p>
              <h2 className="header-name">{user?.nombre ?? 'Usuario'}</h2>
            </div>
          </div>
          <button className="icon-btn logout-btn" onClick={handleLogout} title="Cerrar sesión">
            <IonIcon icon={logOutOutline} />
          </button>
        </div>

        <div className="dashboard-section-title">
          <h3>¿Qué deseas hacer?</h3>
          <p>Selecciona una opción para continuar</p>
        </div>

        <div className="dashboard-actions">

          <button
            className="action-card"
            onClick={() => history.push('/registrar-referido')}
          >
            <div className="action-icon-wrap">
              <IonIcon icon={addCircleOutline} />
            </div>
            <div className="action-info">
              <h4>Registrar Referido</h4>
              <p>Agrega un nuevo referido al sistema</p>
            </div>
            <span className="action-arrow">›</span>
          </button>

          <button
            className="action-card"
            onClick={() => history.push('/ver-referidos')}
          >
            <div className="action-icon-wrap">
              <IonIcon icon={listOutline} />
            </div>
            <div className="action-info">
              <h4>Ver Referidos</h4>
              <p>Consulta la lista de referidos registrados</p>
            </div>
            <span className="action-arrow">›</span>
          </button>

          {user?.rol === 'admin' && (
            <button
              className="action-card"
              onClick={() => history.push('/usuarios')}
            >
              <div className="action-icon-wrap">
                <IonIcon icon={peopleCircleOutline} />
              </div>
              <div className="action-info">
                <h4>Usuarios</h4>
                <p>Administra quién gestiona los referidos</p>
              </div>
              <span className="action-arrow">›</span>
            </button>
          )}

          <button
            className="action-card"
            onClick={() => history.push('/perfil')}
          >
            <div className="action-icon-wrap">
              <IonIcon icon={personOutline} />
            </div>
            <div className="action-info">
              <h4>Mi Perfil</h4>
              <p>Modifica tu nombre y tu usuario</p>
            </div>
            <span className="action-arrow">›</span>
          </button>

          <button
            className="action-card"
            onClick={() => history.push('/cambiar-contrasena')}
          >
            <div className="action-icon-wrap">
              <IonIcon icon={lockClosedOutline} />
            </div>
            <div className="action-info">
              <h4>Cambiar Contraseña</h4>
              <p>Actualiza la contraseña de tu cuenta</p>
            </div>
            <span className="action-arrow">›</span>
          </button>

        </div>

        <p className="dashboard-footer">Sistema de Referidos — {new Date().getFullYear()}</p>
      </div>
    </IonPage>
  );
};

export default Dashboard;
